import './About.css';

const tags = [
  { icon: '📣', label: 'Digital Marketing' },
  { icon: '🤖', label: 'AI-Powered Tools' },
  { icon: '📊', label: 'Data Analytics' },
  { icon: '🌐', label: 'Tamil Nadu Roots' },
  { icon: '🚀', label: 'Growth Partner' },
];

export default function About() {
  return (
    <section id="about" className="about-section">
      <div className="about-inner">

        {/* Founder Image */}
        <div className="about-img-wrap reveal-left">
          <div className="about-accent-dot" />
          <div className="founder-photo-frame">
            {/* Replace founder.jpg with your actual photo */}
            <img
              src="about.jpg"
              alt="Founder of AerialRoot Services"
              onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
            />
            <div className="founder-photo-placeholder">
              <div className="avatar-icon">👤</div>
              <strong>Founder Photo</strong>
              <span>Replace <code>founder.jpg</code> with your image</span>
            </div>
          </div>
          <div className="about-img-badge">🌱 Founder &amp; CEO</div>
        </div>

        {/* Content */}
        <div className="about-content reveal-right">
          <span className="section-label">Our Story</span>
          <div className="about-founder-title">Meet the Founder</div>
          <div className="about-name">Rooted in <em>Purpose,</em><br />Driven by Data</div>

          <p className="about-paragraph">
            AerialRoot Services was born to bridge the gap between Tamil Nadu's brilliant local businesses
            and the <strong>digital world</strong> combining regional insight with global-standard marketing strategy.
          </p>

          <p className="about-paragraph">
            We build <strong>full-funnel digital marketing campaigns</strong> across social media, search, content,
            and e-commerce  crafted to reach your customer in their language, at the right moment.
          </p>

          <p className="about-paragraph">
            Our <strong>proprietary AI tools</strong> automate creatives, segment audiences, and predict performance 
            so your brand grows smarter, faster, and without wasted spend.
          </p>

          <div className="about-tags">
            {tags.map(t => (
              <span key={t.label} className="about-tag">
                <span>{t.icon}</span> {t.label}
              </span>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
